import { User } from "../interfaces/user.interface";
import { ChatComponent } from "../components/ChatComponent";

interface ChatProps {
  user: User;
  onLogout: () => void;
}

export const Chat = ({ user, onLogout }: ChatProps) => {
  return (
    <ChatComponent user={user} onLogout={onLogout}/>
  );
};
